/** Shared react-query key roots for dashboard data. */

/** Key root of the admin-only creation conversation (`useDashboardConversation`). */
export const DASHBOARD_CONVERSATION_KEY_ROOT = "dashboard-conversation";

/** Key root of the admin-only version history (`useDashboardVersions`). */
export const DASHBOARD_VERSIONS_KEY_ROOT = "dashboard-versions";

/**
 * Key root of the admin-only query rows behind a version's widgets
 * (`useDashboardQueryRows`). Not `dashboard-queries`, which is the widget data batch.
 */
export const DASHBOARD_QUERY_ROWS_KEY_ROOT = "dashboard-query-rows";

/**
 * Query-key roots for per-identity dashboard data: the spec, the tab meta (same
 * keys as the spec), the widget batches, the per-widget queries and the
 * admin-only creation conversation, version history and query rows.
 *
 * - `UseCaseDashboardView` scopes the in-flight count that drives the "View as
 *   user" identity-swap veil to these roots, so the page root isn't re-rendered by
 *   unrelated fetches.
 * - `AuthContext` purges these roots when the signed-in Firebase uid changes, so
 *   the next user on the tab is never served the previous user's cached data.
 *
 * Module scope for a stable reference across renders.
 */
export const DASHBOARD_FETCH_KEY_ROOTS: ReadonlySet<string> = new Set([
  "dashboard",
  "use-case-dashboard",
  "dashboard-queries",
  "dashboard-widget-query",
  DASHBOARD_CONVERSATION_KEY_ROOT,
  DASHBOARD_VERSIONS_KEY_ROOT,
  DASHBOARD_QUERY_ROWS_KEY_ROOT,
]);
